import { useEffect, useState } from 'react';

// Import helpers
import { INVOICE_AGREEMENTS } from 'helpers/agreements';
import { areObligatoryAgreementsChecked } from 'components/utilities/hooks/agreements/helpers';

// Import hooks
import { useInvoiceModal } from 'components/elements/organisms/modal/invoice/useInvoiceModal';
import { useRegulation } from 'components/views/offer_configurator/hooks';
import { useUserAgreements } from 'components/utilities';

// Import api
import { useGetInvoiceInfoQuery } from 'store/features/invoice';

export const useInvoice = (needInvoice: boolean) => {
	const { data: invoice = null } = useGetInvoiceInfoQuery();
	const [isModalVisible, setModalVisible] = useState(false);

	const showModal = () => setModalVisible(true);
	const closeModal = () => setModalVisible(false);

	const { agreements } = useRegulation(INVOICE_AGREEMENTS);
	const { confirmedAgreements } = useUserAgreements(INVOICE_AGREEMENTS);

	const areAgreementsValid = areObligatoryAgreementsChecked({ agreements, userAgreementsIds: confirmedAgreements });

	const { methods, isLoading: isInvoiceLoading, handleInvoiceSubmit } = useInvoiceModal({ invoice, closeModal });

	useEffect(() => {
		if (needInvoice) {
			(!invoice || !areAgreementsValid) && showModal();
		} else {
			closeModal();
		}
	}, [needInvoice, areAgreementsValid]);

	return {
		methods,
		invoice,
		agreements,
		isModalVisible,
		isInvoiceLoading,
		areAgreementsValid,
		showModal,
		closeModal,
		handleInvoiceSubmit
	};
};
